export class FooterManager {
  private footerMenuList: NodeListOf<Element>;



  constructor() {
    this.footerMenuList = document.querySelectorAll('.footer-primary__links-title');
    this.init();
  }

  private init(): void {
    this.footerMenuList.forEach(item => {
      item.addEventListener('click', (ev) => this.handleSubMenuClick(ev));
    });
  }


  private async handleSubMenuClick(e: Event): Promise<void> {

    const menuItem = e.target as HTMLElement;
    const parent = menuItem.closest('.footer-primary__links-section');

    if(!parent?.classList.contains('active') ){
      parent?.classList.add('active');
    }else{
      parent?.classList.remove('active');
    }
  }
}

// Initialisation
document.addEventListener('DOMContentLoaded', () => {
  new FooterManager();
});
